// extracted by mini-css-extract-plugin
module.exports = {"baseCard":"card_baseCard__jkOWQ","pageCard":"card_pageCard__5mIxu","contentContainer":"card_contentContainer__EhHj9","image":"card_image__PAYWS","title":"card_title__rl_Un"};